module.exports = __webpack_public_path__ + "medicine_review-6b1a7feb5fc0cd76aa088f099019317b.png";